/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import {
  BookmarkAltIcon,
  CalendarIcon,
  ChartBarIcon,
  CursorClickIcon,
  MenuIcon,
  PhoneIcon,
  PlayIcon,
  RefreshIcon,
  ShieldCheckIcon,
  SupportIcon,
  ViewGridIcon,
  XIcon,
} from "@heroicons/react/outline";
import { ChevronDownIcon } from "@heroicons/react/solid";
import Logo from "../assets/logo-tres-01.png";

const features = [
  {
    name: "Guías",
    href: "/learn",
    icon: CursorClickIcon, 
  },
  {
    name: "Conócenos",
    href: "/about",
    icon: CursorClickIcon,
  },
  {
    name: "Login to Beta dApp",
    href: "https://cks-gating.vercel.app/login",
    icon: CursorClickIcon,
  },
 
];
const callsToAction = [
  { name: "Watch Demo", href: "#", icon: PlayIcon },
  { name: "Contact Sales", href: "#", icon: PhoneIcon },
];



function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
  return (
    <div className="relative bg-gray-50">
      <Popover className="relative bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex justify-between items-center py-4 md:justify-start md:space-x-10">
            <div className="flex justify-start lg:w-0 lg:flex-1">
              <a href="/">
                <span className="sr-only">Workflow</span>
                <img className="h-10 w-auto sm:h-10" src={Logo} alt="" />
              </a>
            </div>
            <div className="-mr-2 -my-2 md:hidden">
              <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-violet-600">
                <span className="sr-only">Open menu</span>
                <MenuIcon className="h-6 w-6" aria-hidden="true" />
              </Popover.Button>
            </div>
            {/* <Popover.Group as="nav" className="hidden md:flex space-x-10">
              
              <a
                href="/learn"
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Guías
              </a>

              <a
                href="/about"
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Conócenos
              </a>
            </Popover.Group> */}
            <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
            <Popover.Group as="nav" className="hidden md:flex space-x-10">
              
              <a
                href="/learn"
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Guías
              </a>

           {/*    <a
                href="/blog"
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Blog
              </a> */}
              <a
                href="/about"
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Conócenos
              </a>
            </Popover.Group>
              <a
                href="https://cks-gating.vercel.app/login"
                className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-violet-600 hover:bg-violet-800"
              >
                Login to Beta dApp
              </a>
              
            </div>
          </div>
        </div>

        <Transition
          as={Fragment}
          enter="duration-200 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Panel
            focus
            className="absolute top-0 inset-x-0 z-10 p-2 transition transform origin-top-right md:hidden"
          >
            <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
              <div className="pt-5 pb-6 px-5">
                <div className="flex items-center justify-between">
                  <div>
                  <a href="/home">
                    <img
                      className="h-10 w-auto"
                      src={Logo}
                      alt="Workflow"
                    />
                    </a>
                  </div>
                  <div className="-mr-2">
                    <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-violet-600">
                      <span className="sr-only">Close menu</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="mt-6">
                  <nav className="grid gap-y-8">
                    {features.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                      >
                        <item.icon
                          className="flex-shrink-0 h-6 w-6 text-violet-600"
                          aria-hidden="true"
                        />
                        <span className="ml-3 text-base font-medium text-gray-900">
                          {item.name}
                        </span>
                      </a>
                    ))}
                  </nav>
                </div>
              </div>
             
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>
    </div>
  );
}
